import React from 'react';
import { Button, Paper } from '@material-ui/core';
import { formatMoney, getIntervalLabel } from './planUtils';

function PlanSelector({ plans, onSelect, classes }) {
  return (
    <div className={classes.plansLayout}>
      <h1 className={classes.plansTitle}>Elegí tu plan</h1>
      <p className={classes.plansSubtitle}>
        Selecciona el plan que mejor se adapte a vos. El pago se completa de
        forma segura con Stripe.
      </p>
      {plans.length === 0 ? (
        <p className={classes.plansSubtitle}>No hay planes disponibles.</p>
      ) : (
        <div className={classes.plansGrid}>
          {plans.map((plan) => (
            <Paper key={plan.priceId} elevation={3} className={classes.planCard}>
              <div>
                <h2 className={classes.planCardName}>{plan.productName}</h2>
                <p className={classes.planCardDescription}>
                  {plan.productDescription}
                </p>
              </div>
              <div>
                <p className={classes.planCardPrice}>
                  {formatMoney(plan.amount, plan.currency)}
                  <span className={classes.planCardInterval}>
                    {getIntervalLabel(plan.interval, plan.intervalCount)}
                  </span>
                </p>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.primaryButton}
                  fullWidth
                  onClick={() => onSelect(plan.priceId)}
                >
                  Elegir plan
                </Button>
              </div>
            </Paper>
          ))}
        </div>
      )}
    </div>
  );
}

export default PlanSelector;
